module.exports = __webpack_public_path__ + "static/media/scroll-3.31ddc212.png";